import { Account } from '@mls-wallet/shared-types';
import { formatAddress } from '@/lib/utils';
import { CopyAddressButton } from '@/components/shared/copy-address-button';

interface AccountDisplayProps {
  account: Account;
  className?: string;
  accountNameClassName?: string;
  addressClassName?: string;
}

export function AccountDisplay({
  account,
  className = '',
  accountNameClassName = '',
  addressClassName = '',
}: AccountDisplayProps) {
  return (
    <div className={`flex flex-col ${className}`}>
      <span className={`font-medium ${accountNameClassName}`}>
        {account.name}
      </span>
      <div className="flex items-center gap-1">
        <span
          className={`text-xs text-muted-foreground font-mono ${addressClassName}`}
        >
          {formatAddress(account.address)}
        </span>
        <CopyAddressButton address={account.address} />
      </div>
    </div>
  );
}
